import { Flex } from '@mantine/core';
import { useState } from 'react';
import ManualRunModal from '@/pages/AutomationPage/components/ManualRunModal/ManualRunModal.tsx';
import StyledButton, { ButtonVariants } from '@/components/StyledButton/StyledButton.tsx';
import { Automation } from '@/types/automations.ts';

type props = {
  automation?: Automation;
  variant?: Exclude<ButtonVariants, 'icon' | 'subtleIcon'>;
};

const AutomationPageManualRunButton = ({ automation, variant }: props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Flex>
      <StyledButton
        size={'md'}
        variant={variant}
        // variant={'outline'}
        // leftSection={<IconPlus size={14} color={'#757575'} stroke={2} />}
        onClick={() => setShowModal(true)}
        styles={{ section: { marginRight: 5 } }}
      >
        Create Manual Run
      </StyledButton>

      <ManualRunModal
        opened={showModal}
        onClose={() => setShowModal(false)}
        automation={automation}
      />
    </Flex>
  );
};

export default AutomationPageManualRunButton;
